import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageAlertComponent } from './message-alert.component';

@NgModule({
  declarations: [
    MessageAlertComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [MessageAlertComponent]
})
export class MessageAlertModule { }
